import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { IntlProvider } from 'react-intl'

import messages from '../i18n/messages.json'

import AppStateContext from '../contexts/AppStateContext'

import { notifySessionPeriod } from '../config/config'
import {
  ACCOUNT_STORE_KEY,
  LIST_STORE_KEY,
  STORE_KEY_LANG,
  STORE_KEY_USER_LANG,
  USER_STORE_KEY,
} from '../helpers/Constants.js'
import { notifyParent } from '../helpers/notifyParent'

import { storeGet, storeRemove, storeSet } from 'mailup-react-helpers'

export const withAppState = (ComponentToWrap) => {
  const WrappedComponent = (props) => {
    return (
      <AppStateContext.Consumer>
        {(value) => (
          <ComponentToWrap
            {...props}
            appStateCtx={value}
            changeLocale={value.changeLocale}
            sessionId={value.sessionId}
            storeGet={value.storeGet}
            storeSet={value.storeSet}
            storeRemove={value.storeRemove}
          />
        )}
      </AppStateContext.Consumer>
    )
  }

  WrappedComponent.displayName = `withAppState(${
    ComponentToWrap.displayName || ComponentToWrap.name
  })`
  return WrappedComponent
}

const AppStateProviderComponent = ({ sessionId, children }) => {
  const [locale, setLocale] = useState(
    storeGet(STORE_KEY_USER_LANG) || storeGet(STORE_KEY_LANG) || 'en',
  )
  const [mounted, setMounted] = useState(false)
  const [notifySessionInterval, setNotifySessionInterval] = useState(null)

  useEffect(() => {
    /*
    const storedLocale = getLang()

    if (storedLocale && (locale !== storedLocale)) {
      setLocale(storedLocale)
    }
    */
    setMounted(true)

    if (!notifySessionInterval) {
      setNotifySessionInterval(setInterval(notifySession, notifySessionPeriod))
    }

    return cleanUpNotifySession
  }, [])

  function notifySession() {
    const sessionInfo = {
      consoleId: storeGet(ACCOUNT_STORE_KEY).Id || '',
      userId: storeGet(USER_STORE_KEY).Id || '',
      listId: storeGet(LIST_STORE_KEY).IdList || '',
    }

    if (sessionInfo.consoleId && sessionInfo.userId) {
      notifyParent('checkFiltersAppSession', [sessionInfo])
    }
  }

  function cleanUpNotifySession() {
    clearInterval(notifySessionInterval)
    setNotifySessionInterval(null)
  }

  const setLangLocale = ({ lang, userLang }) => {
    userLang ? setLocale(userLang.toLowerCase()) : setLocale(lang.toLowerCase())
    storeSet(STORE_KEY_LANG, lang.toLowerCase())
    userLang && storeSet(STORE_KEY_USER_LANG, userLang.toLowerCase())
  }

  function changeLocale(newLocale) {
    setLangLocale(newLocale)
  }

  const appStateCtx = {
    locale,
    changeLocale,

    sessionId,

    storeGet,
    storeSet,
    storeRemove,
  }

  return (
    <AppStateContext.Provider value={appStateCtx}>
      {mounted && (
        <IntlProvider locale={locale} messages={messages[locale]} key={locale}>
          {children}
        </IntlProvider>
      )}
    </AppStateContext.Provider>
  )
}

AppStateProviderComponent.defaultProps = {
  children: undefined,
}

AppStateProviderComponent.propTypes = {
  children: PropTypes.node,
  sessionId: PropTypes.string,
}

export const AppStateProvider = AppStateProviderComponent
